import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "r-loader",
  "use": "r-loader-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"r-loader\">\n<path d=\"M30 4C15.6406 4 4 15.6406 4 30C4 44.3594 15.6406 56 30 56C44.3594 56 56 44.3594 56 30H60C60 46.5686 46.5686 60 30 60C13.4315 60 0 46.5686 0 30C0 13.4315 13.4315 0 30 0V4Z\">\n    <animateTransform attributeType=\"xml\" attributeName=\"transform\" type=\"rotate\" from=\"0 30 30\" to=\"360 30 30\" dur=\"1.4s\" repeatCount=\"indefinite\" />\n</path>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol